import * as yup from 'yup';

import { birthdayReg, nameReg, phoneNumberReg } from '@/lib/regex/personal-info';

export const simpleAuthFormSchema = yup
  .object({
    phone: yup
      .string()
      .length(phoneNumberReg.minLength, phoneNumberReg.patternMessage)
      .required(phoneNumberReg.requiredMessage)
      .matches(phoneNumberReg.regExp, phoneNumberReg.patternMessage),
    name: yup.string().required(nameReg.requiredMessage).matches(nameReg.regExp, nameReg.patternMessage),
    birthDay: yup.string().required(birthdayReg.requiredMessage).matches(birthdayReg.regExp, birthdayReg.patternMessage),
    certType: yup.string().required('본인인증 수단을 선택해주세요.')
  })
  .required();
